import { PropertyFlag } from 'srs-middleware';
import { path } from '../endpoints';

import { TreemapWrapper } from './wrapper';
import { TreemapWidgetKnobs } from './knobs';
import { filterProperties } from 'utilities/srsUtils';

const flags = [PropertyFlag.Hierarchical];

export const config = {
	key: 'TREE_MAP',
	label: 'Treemap',
	icon: 'partition-graph',
	wrapper: TreemapWrapper,
	endpoint: path,
	Knobs: TreemapWidgetKnobs,
	flags: [PropertyFlag.Hierarchical],
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				propertyList: [filteredProperties[0].name],
				parameters: {
					pathDepth: 10000, // Get the whole tree for now
				},
			},
		};
	},
	createDefaultConfiguration: (_filteredProperties) => {
		return {
			showAllLabels: false,
		};
	},
	isValid: (selectedDefinitionName) => {
		return filterProperties(selectedDefinitionName, flags).length >= 1;
	},
};
